import { createContext, useContext } from "react";
import type { ReactNode } from "react";

/**
 * Densidade do painel (I3) — preferência da PESSOA, não da tela.
 *
 * - `comfortable`: o padrão do produto.
 * - `compact`: cards com padding menor, tabela sempre em linha de 44 px e grades com uma
 *   coluna a mais (quem monta a grade lê `useUiDensity()`).
 *
 * O alvo de toque de 44 px NÃO encolhe no compacto: no celular, densidade é sobre o
 * espaço em volta, nunca sobre o tamanho do que se toca.
 */
export type UiDensity = "comfortable" | "compact";

const UiDensityContext = createContext<UiDensity>("comfortable");

export interface DensityProviderProps {
  density: UiDensity;
  children: ReactNode;
}

export function DensityProvider({ density, children }: DensityProviderProps) {
  return <UiDensityContext.Provider value={density}>{children}</UiDensityContext.Provider>;
}

export function useUiDensity(): UiDensity {
  return useContext(UiDensityContext);
}
